import React, { useState } from 'react';
import './Booking.css';
// import PageBanner from '../components/PageBanner/PageBanner';
import { apiCall } from '../utils/api';
import { toast } from 'react-toastify';
import bookingBanner from '../assets/images/booking_banner.png';

import { useLanguage } from '../contexts/LanguageContext';

function Booking() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    state: '',
    address: '',
    preferredTime: '',
    remark: ''
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);



  // Validation functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phone.replace(/\D/g, ''));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'booking.form.errors.name_required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'booking.form.errors.email_required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'booking.form.errors.email_invalid';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'booking.form.errors.phone_required';
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = 'booking.form.errors.phone_invalid';
    }

    if (!formData.city.trim()) {
      newErrors.city = 'booking.form.errors.city_required';
    }

    if (!formData.state.trim()) {
      newErrors.state = 'booking.form.errors.state_required';
    }

    if (!formData.address.trim()) {
      newErrors.address = 'booking.form.errors.address_required';
    }

    if (!formData.preferredTime.trim()) {
      newErrors.preferredTime = 'booking.form.errors.time_required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleWhatsApp = () => {
    const phoneNumber = '919370832534';
    const message = `Hello! I would like to book a session.`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        await apiCall('/bookings', 'POST', formData);

        setSubmitted(true);
        // Reset form after 3 seconds
        setTimeout(() => {
          setFormData({
            name: '',
            email: '',
            phone: '',
            city: '',
            state: '',
            address: '',
            preferredTime: '',
            remark: ''
          });
          setSubmitted(false);
        }, 3000);
      } catch (error) {
        toast.error('Failed to submit booking: ' + error.message);
      }
    }
  };

  return (
    <div className="booking">
      {/* Dynamic Page Banner from Admin */}
      {/* Custom Booking Page Banner */}
      <div className="booking-page-banner-wrapper">
        <img
          src={bookingBanner}
          alt={t('booking.banner.title')}
          className="booking-main-banner"
        />
        <div className="booking-banner-overlay">
          <h1>{t('booking.banner.title')}</h1>
        </div>
      </div>

      {/* Booking Form Section */}
      <section className="booking-section">
        <div className="container">
          <div className="booking-wrapper">
            <div className="form-container">
              <h2 style={{ color: 'white' }}>{t('booking.form.title')}</h2>

              {submitted ? (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>{t('booking.form.success.title')}</h3>
                  <p>{t('booking.form.success.desc')}</p>
                  <p className="success-details">
                    {t('booking.form.success.follow_up')} {formData.phone}
                  </p>
                  <button
                    className="whatsapp-btn-success"
                    onClick={handleWhatsApp}
                  >
                    💬 {t('booking.form.success.whatsapp')}
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="booking-form">
                  {/* Name Field */}
                  <div className="form-group">
                    <label htmlFor="name">{t('booking.form.name')}</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder={t('booking.form.name_placeholder')}
                      className={errors.name ? 'input-error' : ''}
                    />
                    {errors.name && <span className="error-message">{t(errors.name)}</span>}
                  </div>

                  {/* Email Field */}
                  <div className="form-group">
                    <label htmlFor="email">{t('booking.form.email')}</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder={t('booking.form.email_placeholder')}
                      className={errors.email ? 'input-error' : ''}
                    />
                    {errors.email && <span className="error-message">{t(errors.email)}</span>}
                  </div>

                  {/* Phone Field */}
                  <div className="form-group">
                    <label htmlFor="phone">{t('booking.form.phone')}</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder={t('booking.form.phone_placeholder')}
                      className={errors.phone ? 'input-error' : ''}
                    />
                    {errors.phone && <span className="error-message">{t(errors.phone)}</span>}
                  </div>

                  {/* City Field */}
                  <div className="form-group">
                    <label htmlFor="city">{t('booking.form.city')}</label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder={t('booking.form.city_placeholder')}
                      className={errors.city ? 'input-error' : ''}
                    />
                    {errors.city && <span className="error-message">{t(errors.city)}</span>}
                  </div>

                  {/* State Field */}
                  <div className="form-group">
                    <label htmlFor="state">{t('booking.form.state')}</label>
                    <input
                      type="text"
                      id="state"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      placeholder={t('booking.form.state_placeholder')}
                      className={errors.state ? 'input-error' : ''}
                    />
                    {errors.state && <span className="error-message">{t(errors.state)}</span>}
                  </div>

                  {/* Address Field */}
                  <div className="form-group">
                    <label htmlFor="address">{t('booking.form.address')}</label>
                    <input
                      type="text"
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder={t('booking.form.address_placeholder')}
                      className={errors.address ? 'input-error' : ''}
                    />
                    {errors.address && <span className="error-message">{t(errors.address)}</span>}
                  </div>

                  {/* Preferred Time */}
                  <div className="form-group">
                    <label htmlFor="preferredTime">{t('booking.form.time')}</label>
                    <input
                      type="text"
                      id="preferredTime"
                      name="preferredTime"
                      value={formData.preferredTime}
                      onChange={handleChange}
                      placeholder={t('booking.form.time_placeholder')}
                      className={errors.preferredTime ? 'input-error' : ''}
                    />
                    {errors.preferredTime && <span className="error-message">{t(errors.preferredTime)}</span>}
                  </div>

                  {/* Remark Field */}
                  <div className="form-group">
                    <label htmlFor="remark">{t('booking.form.remark')}</label>
                    <textarea
                      id="remark"
                      name="remark"
                      value={formData.remark}
                      onChange={handleChange}
                      placeholder={t('booking.form.remark_placeholder')}
                      rows="4"
                      className="remark-textarea"
                    />
                  </div>

                  {/* Live Booking Summary */}
                  {(formData.name || formData.email || formData.phone || formData.preferredTime || formData.city || formData.state || formData.address || formData.remark) && (
                    <div className="booking-summary">
                      <h4>{t('booking.summary.title')}</h4>
                      {formData.name && (
                        <p><span>{t('booking.summary.name')}</span> {formData.name}</p>
                      )}
                      {formData.email && (
                        <p><span>{t('booking.summary.email')}</span> {formData.email}</p>
                      )}
                      {formData.phone && (
                        <p><span>{t('booking.summary.phone')}</span> {formData.phone}</p>
                      )}
                      {formData.city && (
                        <p><span>{t('booking.summary.city')}</span> {formData.city}</p>
                      )}
                      {formData.state && (
                        <p><span>{t('booking.summary.state')}</span> {formData.state}</p>
                      )}
                      {formData.address && (
                        <p><span>{t('booking.summary.address')}</span> {formData.address}</p>
                      )}
                      {formData.preferredTime && (
                        <p><span>{t('booking.summary.time')}</span> {formData.preferredTime}</p>
                      )}
                      {formData.remark && (
                        <p><span>{t('booking.summary.remark')}</span> {formData.remark}</p>
                      )}
                    </div>
                  )}

                  {/* Submit Button */}
                  <button type="submit" className="submit-btn">
                    {t('booking.form.submit')}
                  </button>
                </form>
              )}
            </div>

            {/* Info Box */}
            <div className="info-box">
              <h3>{t('booking.info.title')}</h3>
              <ul className="info-list">
                <li>✓ {t('booking.info.l1')}</li>
                <li>✓ {t('booking.info.l2')}</li>
                <li>✓ {t('booking.info.l3')}</li>
                <li>✓ {t('booking.info.l4')}</li>
                <li>✓ {t('booking.info.l5')}</li>
              </ul>

              <div className="contact-info">
                <h4>{t('booking.info.contact_title')}</h4>
                <p>📞 +91 9370832534</p>
                <p>📧 iyogakaregaindia@gmail.com</p>
                <p>📍 119 Sector 15 Ava's Vikas Colony Sikandra Agra </p>

                <button type="button" className="whatsapp-btn" onClick={handleWhatsApp}>
                  💬 {t('booking.info.whatsapp')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Booking;
